//==============================
// Gallery Slider
//==============================

var gallerySlider = $('.gallery-slider');

gallerySlider.slick({
  autoplay: false,
  speed: 500,
  slidesToShow: 1,
  infinite: true,
  // slidesToScroll: 3,
  swipeToSlide: true,
  dots: true,
  arrows: true,
  centerMode: true,
  variableWidth: true
});
